const Routes = {
    home: '/',
    aboutStellar: '/ve-Stellar',

    bookRoom: '/dat-phong',
    conferenceEvents: '/hoi-thao-su-kien',
    contact: '/lien-he',
    infoAccount: '/thong-tin-tai-khoan',
    listOfTransaction: '/danh-sach-giao-dich',
    myReservation: '/dat-cho-cua-toi',
    passwordAndSecuruty: '/mat-khau-bao-mat',
    changePass: '/doi-mat-khau',
    pay: '/thanh-toan',
    restaurentAndBar: '/nha-hang-quan-bar',
    utilities: '/tien-ich',
    viewPrice: '/xem-gia',
    signIn: '/dang-nhap',
    register: '/dang-ki',
    forgotPassword: '/quen-mat-khau',
    OTP: '/lay-OTP',

    error: '*',
};

export default Routes;
